import { useContext, createContext, useState, useEffect, useCallback } from 'react'

import { ToggleRichTextModalEvent, togglePostModalEventListener } from 'src/utils/customEvents'
import { MODAL_ACTIONS } from 'src/utils/customEvents/types'

import PostModalPublication from '../../postModalPublication'
import type {
  PostModalContextProps,
  PostModalProviderProps,
  SuggestionIA
} from './usePostModal.types'

const PostModalContext = createContext<PostModalContextProps>({} as PostModalContextProps)

export const PostModalProvider = ({ children }: PostModalProviderProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false)
  const [suggestionIA, setSuggestionIA] = useState<SuggestionIA>({
    title: '',
    description: ''
  })

  useEffect(() => {
    togglePostModalEventListener(
      /* istanbul ignore next */ (event) => {
        const payload = (event as CustomEvent<ToggleRichTextModalEvent>).detail

        switch (payload.action) {
          case MODAL_ACTIONS.CLOSE:
            setIsOpen(false)

            payload.showFullScreen && setIsFullScreen(true)

            break
          case MODAL_ACTIONS.OPEN:
            setIsOpen(true)

            setIsFullScreen(false)
            payload.suggestionsIA && setSuggestionIA(payload.suggestionsIA)
            break
        }
      }
    )
  }, [])

  const handleSuggestionIA = useCallback(
    (suggestionIA: SuggestionIA) => {
      setSuggestionIA(suggestionIA)
    },
    [setSuggestionIA]
  )

  return (
    <PostModalContext.Provider
      value={{
        setIsOpen,
        handleSuggestionIA,
        suggestionIA,
        isFullScreen,
        isOpen
      }}
    >
      <PostModalPublication />
      {children}
    </PostModalContext.Provider>
  )
}

export const usePostModal = () => {
  const context = useContext(PostModalContext)

  return context
}

export default usePostModal
